export default __webpack_public_path__ + "static/media/undraw_error.ea6d32d1.svg";